import { render, staticRenderFns } from "./PlatformIconList.vue?vue&type=template&id=6bdb4a28&scoped=true"
import script from "./PlatformIconList.vue?vue&type=script&lang=js"
export * from "./PlatformIconList.vue?vue&type=script&lang=js"
import style0 from "./PlatformIconList.vue?vue&type=style&index=0&id=6bdb4a28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdb4a28",
  null
  
)

export default component.exports